import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const NecromancySvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M51.8 30.6c1.8-5.4 0-11.6-4.6-15.4-9.5-8-21.1-5.5-23.6-5-4.7 1-9 2.8-12.2 6.6C8 20.7 6.6 25 8 30q1 2.5 2.6 5 1 1.2 0 2.6l-1 2.1q-1.4 3-.5 6c1.3 4.1 4.9 5.5 8.5 4.5 3.3-.9 5.2-5 3.8-8.5-1-2.6-3-4.6-3.6-5.2q-1-1 0-2l2.7-3q1.3-1.6.7-2.3c-1.1-1-2 .2-2.9.7q-1.4 1-2.7 2.3-1.2 1-2-.1a9 9 0 0 1-1.7-6.3 11 11 0 0 1 5.7-8.6 25 25 0 0 1 24.1-.5q3.2 1.6 5 4.8 2.8 4.7.3 9.6c-1 2-1.5 2-3.2.6l-3.8-3c-.7-.5-1.6.2-1.6 1.1s.6 1.4 1.2 2q1.4 1.3 2.6 2.6c.9 1 .8 1.2 0 2.3q-1.7 1.9-3 3.8a7 7 0 0 0 .3 7.6c2.5 3.2 8.7 3.2 10.7-1.3q2-4.2-.4-8c-1.4-2-1.2-3.3.4-5q1-1.4 1.5-3.1M14 40q.6-.5 1.1-.2c1.5.6 2.8 2.9 2.7 4.3q0 1.8-1.6 2.2-1.6.3-2.5-1c-1-1.4-.9-4 .3-5.3m33.4 3.3-.1 1c-.4 1.6-1.8 2.6-3.2 2.2q-2-.8-1.6-3.2c.3-1.7 1.5-2.8 2.8-3.8q.7-.3 1.1.3 1.1 1.5 1 3.5"
      />
    </BaseSvg>
  );
};

export default NecromancySvg;
